import React, { useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setEditSection, setVideo } from '../../../../../../Features/lensSlice';
import TrimSlider from './TrimSlider';
import { VideoContext } from '../../../../../../Context/VideoContext';
import { convertToHHMMSS } from '../../../../../../lib/utils/utils';

import { fetchFile } from '@ffmpeg/util';
import { FFmpeg } from '@ffmpeg/ffmpeg';

import { showToast } from '../../../../../../Components/Toaster/Toaster';

let ffmpeg; //Store the ffmpeg instance

function TrimEdit() {
    const dispatch = useDispatch();
    const video = useSelector((state) => state.lens.media.video);

    const { videoRef, videoFile, setVideoFile, setLoading } = useContext(VideoContext);

    const [currentTime, setCurrentTime] = useState(0);

    const [startSliderValue, setStartSliderValue] = useState(0);
    const [endSliderValue, setEndSliderValue] = useState(0);

    const [duration, setDuration] = useState(0);

    useEffect(() => {
        if (video.url) {
            const videoElement = document.createElement('video');
            videoElement.src = video.url;
      
            const handleLoadedMetadata = () => {
                setDuration(videoElement.duration.toFixed(2));
                setEndSliderValue(videoElement.duration.toFixed(2));
            };
      
            videoElement.addEventListener('loadedmetadata', handleLoadedMetadata);
      
            return () => {
                videoElement.removeEventListener('loadedmetadata', handleLoadedMetadata);
            };
        }
    }, [video]);

    const handleCancel = () => {
        dispatch(setEditSection(null));
    }

    useEffect(() => {
        const videoElement = videoRef.current;

        if (videoElement) {
            const handleTimeUpdate = () => {
                setCurrentTime(videoElement.currentTime.toFixed(0));
            };

            videoElement.addEventListener("timeupdate", handleTimeUpdate);

            return () => {
                videoElement.removeEventListener("timeupdate", handleTimeUpdate);
            };
        }
    }, [videoRef]);

    // Trimming Functionality

    const [isScriptLoaded, setIsScriptLoaded] = useState(false);

    const handleConfirmTrim = async () => {
        const diff = endSliderValue - startSliderValue;

        // eslint-disable-next-line eqeqeq
        if(diff != duration) {
            setLoading(true);
            if (isScriptLoaded) {
                const { type } = videoFile;
                const videoData = await fetchFile(videoFile);
    
                try {
                    await ffmpeg.writeFile('video.mp4', videoData);
                }
                catch(err) {
                    setLoading(false);
                    showToast('Error trimming video', 'error');
                    return;
                }
    
                const videoFileType = type.split('/')[1];
    
                await ffmpeg.exec([
                    '-i',
                    'video.mp4',
                    '-ss',
                    `${convertToHHMMSS(startSliderValue)}`,
                    '-to',
                    `${convertToHHMMSS(endSliderValue)}`,
                    '-c:v',
                    'libx264',
                    '-c:a',
                    'aac',
                    '-strict',
                    'experimental',
                    `out.${videoFileType}`,
                ])
                .then(() => {
                    setLoading(false);
                })
                .catch((error) => {
                    console.error('Promise rejected:', error);
                    setLoading(false);
                });
    
                const data = await ffmpeg.readFile(`out.${videoFileType}`);
                const trimmedBlob = new Blob([data.buffer], { type: 'video/mp4' });
                const url = URL.createObjectURL(trimmedBlob);
    
                // Create File from blob
                const fileName = 'output.mp4';
                const trimmedFile = new File([trimmedBlob], fileName, { type: 'video/mp4' });
    
                setVideoFile(trimmedFile);
                dispatch(setVideo({
                    id: video.id,
                    url: url,
                }));
    
                dispatch(setEditSection(null));
                showToast('Trim ssuccessful!', 'success');
            }
        }
        else {
            showToast('Please adjust the sliders before trimming', 'warning');
        }
    };

    useEffect(() => {
        const loadffmpeg = async () => {
            ffmpeg = new FFmpeg();
            await ffmpeg.load({ log: true });
            setIsScriptLoaded(true);
        }

        loadffmpeg();
    }, []);

    return (
        <div className='relative flex flex-col size-full p-4 bg-[#FFFFFF]'>
            <div className="flex items-center justify-between">
                <h1 className='font-medium text-[16px] leading-5 text-[#121212]'>Trim</h1>

                <button 
                    onClick={handleCancel} 
                    className='underline font-medium text-[14px] leading-5 text-[#1055EB]'
                >Cancel</button>
            </div>

            <div className="absolute bottom-32 px-4 left-0 w-full flex flex-col items-center gap-4">
                <p className='font-normal text-[14px] leading-[22px] text-[#808080]'><span className='text-[#121212]'>00:{currentTime < 10 ? `0${currentTime}` : currentTime}</span> / 00:{parseInt(duration)}</p>

                <TrimSlider 
                    min={0} 
                    max={duration} 
                    step={1} 
                    onStartChange={setStartSliderValue} 
                    onEndChange={setEndSliderValue} 
                    start={startSliderValue} 
                    end={endSliderValue} 
                />
            </div>

            <div className="absolute bottom-0 left-0 w-full px-4 py-3 bg-[#FFFFFF] border-t border-[#EAEAEA]">
                <button onClick={handleConfirmTrim} className='cursor-pointer w-full px-4 py-[6px] rounded-md bg-primaryColor hover:bg-primaryAccent font-semibold text-[14px] leading-[26px] text-buttonText'>Confirm Trim</button>
            </div>
        </div>
    );
}

export default TrimEdit;
